import { useCallback } from 'react';
import { useGetUserFirstNameWithFallback } from '../use-get-user-first-name-with-fallback';
import { useGetUserLastNameWithFallback } from '../use-get-user-last-name-with-fallback';

type P = {
  firstName?: null | string;
  lastName?: null | string;
  middleName?: null | string;
};

export const useGetUserFullNameWithFallback = () => {
  const getFirstNameWithFallback = useGetUserFirstNameWithFallback();
  const getLastNameWithFallback = useGetUserLastNameWithFallback();

  return useCallback(
    ({ firstName, lastName, middleName }: P = {}) =>
      [getFirstNameWithFallback({ firstName, lastName }), middleName, getLastNameWithFallback({ firstName, lastName })]
        .filter(Boolean)
        .join(' ')
        .trim(),
    [getFirstNameWithFallback, getLastNameWithFallback],
  );
};
